export const dataExamResult = {
  type: 'object',
  required: ['Field', 'Value'],
  properties: {
    Field: {
      type: 'string',
    },
    Value: {
      type: 'string',
    },
  },
};
